import React from 'react'
import ControllerModalBrowserBrowser from './ControllerModalBrowserBrowser'
import ControllerModalBrowserSlideshow from './ControllerModalBrowserSlideshow'

export default function ControllerModalBrowser({ status, onClose }) {
    if (status.modalInteractionMode === 'slideshow') {
        return <ControllerModalBrowserSlideshow onClose={onClose} />
    }
    return (
        <ControllerModalBrowserBrowser
            items={status.modalItems || []}
            regions={status.modalRegions || []}
            unscoped={status.modalUnscoped || []}
            pageTitle={status.modalPageTitle || ''}
            focusedId={status.modalFocusedId}
            url={status.modalUrl || ''}
            canGoBack={status.modalCanGoBack || false}
            canGoForward={status.modalCanGoForward || false}
            scrollTop={status.modalScrollTop || 0}
            scrollHeight={status.modalScrollHeight || 0}
            clientHeight={status.modalClientHeight || 0}
            debug={status.modalDebug || null}
            onClose={onClose}
        />
    )
}
